import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import Icon from 'components/UI/Icon';

import useIntersection from 'hooks/useIntersection';

import '@/styles/sections/pages/Home/hero.scss';

// TODO: переделать на стилевые модули
const Hero = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.6,
  });

  return (
    <section className="cr-home-hero-sec cr-dark-blue-bg" ref={scrollWrapper}>
      <div
        className={classnames('cr-wrap cr-home-hero', {
          'js-anim-init': inViewSec,
        })}
      >
        <div className="cr-home-hero__header">
          <h1 className="cr-h1 cr-white cr-hero-title">
            {data.title}&#160;
            <span
              className={classnames('cr-main cr-hero-title__extra')}
              data-splitting="chars"
            >
              {data.titleHighlighted}
            </span>
          </h1>

          <p className="cr-lead cr-white cr-opacity-05 cr-hero-description">
            {data.description}
          </p>
        </div>

        <div className="cr-home-hero__tiles-wrap" ref={inViewRefSec}>
          <ul className="cr-tiles">
            {data.tiles.map((tile, i) => (
              // TODO: вынести в отдельный компонент
              <li key={i} className="cr-white cr-tiles__item">
                <Link to={tile.heroTileItemLink.uri} className="cr-tiles__tile">
                  <p className="cr-tiles__tile-wrap">
                    <i className="cr-tiles__tile--icon-item">
                      <img src={tile.heroTileItemImage?.sourceUrl} alt="" />
                    </i>
                    <i className="cr-tiles__tile--icon-arrow">
                      <Icon name="corner-arrow-small" />
                    </i>
                  </p>
                  <h3 className="cr-h3 cr-tiles__tile--title">
                    {tile.heroTileItemTitle}
                  </h3>
                  <p className="cr-reg cr-opacity-05 cr-tiles__tile--description">
                    {tile.heroTileItemDescription}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Hero;
